var _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-labelledby": titleId,
    role: "img",
    width: "100%",
    height: "100%",
    viewBox: "0 0 400 38",
    preserveAspectRatio: "none",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "loading-1-aria"
  }, "Loading...") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "loading-1-aria"
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    role: "presentation",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    clipPath: "url(#loading-1-diff)",
    style: {
      fill: "url(#loading-1-animated-diff)"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "loading-1-diff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    rx: 8,
    ry: 8,
    width: 400,
    height: 50
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "loading-1-animated-diff"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "rgba(255,255,255,0)",
    stopOpacity: 1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    values: "-2; -2; 1",
    keyTimes: "0; 0.25; 1",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "rgba(0,0,0,.1)",
    stopOpacity: 1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    values: "-1; -1; 2",
    keyTimes: "0; 0.25; 1",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "rgba(255,255,255,0)",
    stopOpacity: 1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    values: "0; 0; 3",
    keyTimes: "0; 0.25; 1",
    dur: "2s",
    repeatCount: "indefinite"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.e0e81a53776539addbd98f9aafaa066b.svg";
export { ForwardRef as ReactComponent };